<template>
    <div id="content" style="overflow-x: hidden;overflow-y: auto; background-color: #F2F2F2">
        <div>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-card class="box-card">
                        <el-row>
                            <el-col :span="22" :offset="2">
                                <div style="float:right;">
                                <dept-select-new v-show="false" ref="deptRef" v-model="deptids" @fetchAllDepts="fetchAllDepts"
                                                 @change="deptChangeHandler"></dept-select-new>
                                &nbsp;&nbsp;
                                <span class="grey-font font-12" v-show="searchType=='week'">（<b>周只针对地区概况和PUE这两个板块</b>）&nbsp;&nbsp;</span>
                                <el-select v-model="searchType" placeholder="按照周" size="small"  style="margin-top:-6px;margin-right:5px;"><!--@change="weekAndMonthChnage"-->
                                    <el-option
                                            v-for="item in optionsThree"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                                    <!--@change="weekChange"-->
                                <el-date-picker v-if="searchType=='week'"
                                                v-model="searchWeek"
                                                size="small"
                                                :picker-options="pickerWeek"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                :editable="false"
                                                :clearable="false"
                                                placeholder="选择日期" style="margin-top:-6px;width:240px;">
                                </el-date-picker>
                                    <!--@change="dataChange"-->
                                <el-date-picker
                                        v-if="searchType=='month'"
                                        size="small"
                                        v-model="searchDate"
                                        type="month"
                                        :editable="false"
                                        :clearable="false"
                                        :picker-options="pickerMonth"
                                        placeholder="选择月"
                                        value-format="yyyy-MM"
                                        style="margin-right: 10px;">
                                </el-date-picker>
                                &nbsp;
                                <el-button @click="searchHandler" type="primary" size="small">搜索</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top: 10px;">
                <SysRoomBoard ref="sysRoomBoard"></SysRoomBoard>
                <SysRoomBoardArea ref="sysRoomBoardArea"></SysRoomBoardArea>
            </el-row>
            <el-row :gutter="10" style="margin-top: 10px;">
                <AllRound ref="allRound"></AllRound>
                <PueSituation ref="pueSituation"></PueSituation>
            </el-row>
            <el-row style="margin-top: 0px;">
                <reliable :deptids="deptids" :deptMap="deptMap" :searchDate="searchDateNew"></reliable>
            </el-row>

            <el-row :gutter="10" style="margin-top:10px;">
                <el-col :span="14">
                    <el-card class="box-card" style="height:590px;">
                        <workorder-completion-rate :dcnumMap="dcnumMap" :dcnumids="dcnumidsWithAuth"
                                                   :searchDate="searchDateNew"></workorder-completion-rate>
                    </el-card>
                </el-col>
                <el-col :span="10">
                    <ticket-problem-change :dcnumMap="dcnumMap" :dcnumids="dcnumidsWithAuth"
                                           :searchDate="searchDateNew"></ticket-problem-change>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

    import Reliable from "@/views/board/boss/reliable/reliable";
    import SysRoomBoard from '@/views/board/boss/sysRoomRelevant/sysRoomBoard'
    import SysRoomBoardArea from '@/views/board/boss/sysRoomRelevant/sysRoomBoardArea'
    import AllRound from '@/views/board/boss/pueAndAllRound/allRound'
    import PueSituation from '@/views/board/boss/pueAndAllRound/pueSituation'
    import "@/assets/css/athub-v3.css"
    import TicketProblemChange from "@/views/board/boss/ticketProblemChange/index"
    import WorkorderCompletionRate from "@/views/board/boss/workorderCompletionRate"
    import CommonApi from "@/api/common";
    import {debounce} from '../../../util'
    import DeptSelectNew from '@/components/dept/deptNew'

    let that;

    export default {
        name: "bossBoard",

        components: {
            TicketProblemChange,
            Reliable,
            SysRoomBoard,
            SysRoomBoardArea,
            AllRound,
            PueSituation,
            WorkorderCompletionRate,
            DeptSelectNew,
        },

        data() {
            return {
                deptList: [],
                deptids: [],
                deptidsWithAuth: [],    //有权限的运行中的部门
                deptMap: null,

                searchDateNew: new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1),    //按了搜索按钮触发条件变更

                dcnumids: [],
                dcnumidsWithAuth: [],   //有权限的运作中的数据中心
                dcnumMap: null,
                searchWeek:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1)+ '-'+new Date().getDate(),
                searchDate: new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1),
                dcnumidsBoard: [],//存放准备赋值给机柜页面的数据中心信息集合

                optionsThree:[
                    {'label':'周','value':'week'},
                    {'label':'月','value':'month'}],
                searchType:'month',//查询周或者月
                pickerWeek:{
                    disabledDate(time) {
                        return time.getTime() > new Date().getTime(); //不可以选择今天之后的日期
                    }
                },
                pickerMonth:{
                    disabledDate(time) {
                        return time.getTime() > new Date().getTime(); //不可以选择今天之后的日期
                    }
                }
            }
        },

        created() {
            that = this;
        },

        async mounted() {
            this.dcnumMap = new Map();

            CommonApi.getRunningDeptListByAuth().then(res => {
                for (let i = 0; i < res.length; i++) {
                    this.deptidsWithAuth.push(res[i].id);
                }
                return CommonApi.getRoomsByDeptIds(this.deptidsWithAuth);
            }).then((res) => {
                this.dcnumidsWithAuth = res.map(e => e.id);
            });

        },

        methods: {

            searchHandler() {
                this.searchDateNew = this.searchDate;

                if(this.searchType=='month'){
                    //调用机柜子页面查询数据
                    this.$refs.sysRoomBoard.searchMonth = this.searchDate;
                    this.$refs.sysRoomBoard.roomChangeFun(false);

                    //在赋值给数据中心综合能力的日期选择框（隐藏了），目前综合能力那边得日期用得是父页面得日期选择框
                    this.$refs.allRound.searchMouth = this.searchDate;
                    this.$refs.allRound.nouthChange();
                }


                //促发PUE查询
                this.$refs.pueSituation.searchType=this.searchType;

                //如果PUE子页面是月份下拉框，值赋值给PUE子页面的月控件
                if (this.$refs.pueSituation.searchType == 'month') {
                    //调用子页面PUE页面查询数据
                    this.$refs.pueSituation.searchMouth = this.searchDate;
                    //赋值子页面PUE页面的数据中心MAP
                    this.$refs.pueSituation.sysRoomMap = this.dcnumMap;
                    this.$refs.pueSituation.weekAndMonthChangeFun(false);
                }

                //促发PUE查询
                if (this.$refs.pueSituation.searchType == 'week') {
                    //调用子页面区域面查询数据
                    this.$refs.pueSituation.searchDate = this.searchWeek;
                    //赋值子页面PUE页面的数据中心MAP
                    this.$refs.pueSituation.sysRoomMap = this.dcnumMap;
                    this.$refs.pueSituation.weekAndMonthChangeFun(false);
                }

                //促发地区概况查询
                this.$refs.sysRoomBoardArea.searchType=this.searchType;
                //如果区域（华南华北华东）子页面是月份下拉框，值赋值给区域子页面的月控件
                if (this.$refs.sysRoomBoardArea.searchType == 'month') {
                    //调用子页面区域面查询数据
                    this.$refs.sysRoomBoardArea.searchMouth = this.searchDate;
                    this.$refs.sysRoomBoardArea.changeHandler(false);
                }

                //促发地区概况查询
                if (this.$refs.sysRoomBoardArea.searchType == 'week') {
                    //调用子页面区域面查询数据
                    this.$refs.sysRoomBoardArea.searchDate = this.searchWeek;
                    this.$refs.sysRoomBoardArea.changeHandler(false);
                }

            },

            //日期修改促发事件
            dataChange() {
                this.$refs.sysRoomBoard.searchMonth = this.searchDate;
                //this.$refs.sysRoomBoard.searchMonth=this.searchDate.getFullYear()+'-'+this.addZero(this.searchDate.getMonth()+1);
                //调用机柜子页面查询数据
                this.$refs.sysRoomBoard.roomChangeFun(false);

                //在赋值给数据中心综合能力的日期选择框（隐藏了），目前综合能力那边得日期用得是父页面得日期选择框
                this.$refs.allRound.searchMouth = this.searchDate;
                this.$refs.allRound.nouthChange();

                //如果PUE子页面是月份下拉框，值赋值给PUE子页面的月控件
                if (this.$refs.pueSituation.searchType == 'month') {
                    //调用子页面PUE页面查询数据
                    this.$refs.pueSituation.searchMouth = this.searchDate;
                    //赋值子页面PUE页面的数据中心MAP
                    this.$refs.pueSituation.sysRoomMap = this.dcnumMap;
                    this.$refs.pueSituation.weekAndMonthChangeFun(false);
                }


                //如果区域（华南华北华东）子页面是月份下拉框，值赋值给区域子页面的月控件
                if (this.$refs.sysRoomBoardArea.searchType == 'month') {
                    //调用子页面区域面查询数据
                    this.$refs.sysRoomBoardArea.searchMouth = this.searchDate;
                    this.$refs.sysRoomBoardArea.changeHandler(false);
                }
            },

            addZero(num) {
                if (parseInt(num) < 10) {
                    num = '0' + num;
                }
                return num;
            },

            async deptChangeHandler() {
                this.dcnumids = [];
                this.$refs.sysRoomBoard.searchSysRoom = [];
                this.$refs.sysRoomBoard.sysRooms = [];
                this.$refs.pueSituation.sysRooms = [];
                if (this.deptids.length == 0) {
                    this.deptids = this.$refs['deptRef'].deptIdsAll;
                    await debounce(CommonApi.getRoomsByDeptIds(this.$refs['deptRef'].deptIdsAll).then(res => {
                        this.dcnumChangeHandler(res);
                    }), 500);
                } else {
                    this.deptids.forEach(e => {
                        this.deptids = this.deptids.filter(e => {
                            return e != '全部';
                        })
                    });
                    await debounce(CommonApi.getRoomsByDeptIds(this.deptids).then(res => {
                        this.dcnumChangeHandler(res);
                    }), 500);
                }
            },

            fetchAllDepts(value) {
                this.deptMap = this.$refs['deptRef'].deptMap;
            },

            dcnumChangeHandler(res) {
                this.dcnumidsBoard = res;
                this.dcnumids = res.map(e => {
                    return e.id;
                });
                for (let i = 0; i < res.length; i++) {
                    this.dcnumMap.set(res[i].id + '', res[i].name);
                }

                this.$refs.sysRoomBoard.searchSysRoom = [];
                //根据部门获取对应的数据中心赋值子页面机柜数据
                this.$refs.sysRoomBoard.sysRooms = this.dcnumidsBoard;
                for (var j = 0; j < this.dcnumidsBoard.length; j++) {
                    this.$refs.sysRoomBoard.searchSysRoom.push(this.dcnumidsBoard[j].dcNum);
                }
                //赋值子页面机柜页面日期
                this.$refs.sysRoomBoard.searchMonth = new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1);
                //调用机柜子页面查询数据
                this.$refs.sysRoomBoard.roomChangeFun(false);
                //赋值子页面PUE数据
                this.$refs.pueSituation.sysRooms = this.dcnumids;
                //赋值子页面PUE页面的数据中心MAP
                this.$refs.pueSituation.sysRoomMap = this.dcnumMap;
                //调用PUE页面查询数据
                this.$refs.pueSituation.weekAndMonthChangeFun(false);
                //调用区域（华南华北华东）子页面查询数据
                this.$refs.sysRoomBoardArea.changeHandler(false);
            },
            // 选择周或者月份下拉框促发事件
            weekAndMonthChnage(){
                //促发地区概况查询
                this.$refs.sysRoomBoardArea.searchType=this.searchType;
                this.$refs.sysRoomBoardArea.changeHandler(false);
                //促发PUE查询
                this.$refs.pueSituation.searchType=this.searchType;
                this.$refs.pueSituation.weekAndMonthChangeFun(false);

                if(this.searchType=='month'){
                    this.$refs.sysRoomBoard.searchMonth = this.searchDate;
                    //调用机柜子页面查询数据
                    this.$refs.sysRoomBoard.roomChangeFun(false);
                }
            },
            //周时间框促发时间
            weekChange(){
                //促发地区概况查询
                if (this.$refs.sysRoomBoardArea.searchType == 'week') {
                    //调用子页面区域面查询数据
                    this.$refs.sysRoomBoardArea.searchDate = this.searchWeek;
                    this.$refs.sysRoomBoardArea.changeHandler(false);
                }
                //促发PUE查询
                if (this.$refs.pueSituation.searchType == 'week') {
                    //调用子页面区域面查询数据
                    this.$refs.pueSituation.searchDate = this.searchWeek;
                    //赋值子页面PUE页面的数据中心MAP
                    this.$refs.pueSituation.sysRoomMap = this.dcnumMap;
                    this.$refs.pueSituation.weekAndMonthChangeFun(false);
                }
            }
        },

    }
</script>

<style scoped>
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 220px;
    }
</style>